import { connect } from 'react-redux';
import EventFromView from './index'
import {loadAlbums, saveAlbum, updateAlbum} from '../../actions/Albums'
import { formValueSelector } from 'redux-form'

const mapStateToProps = (state, props) => {
    return {
	getFormValue: (name) => {
	    return formValueSelector('album')(state, name)
	}
    }
}

const mapDispatchToProps = (dispatch, state) => {    
    return {
	saveAlbum: (data) => {
	    return dispatch(saveAlbum(data)).then(() =>  dispatch(loadAlbums()))
	},
	updateAlbum: (data) => {
	    return dispatch(updateAlbum(data)).then(() =>  dispatch(loadAlbums()))
	}
    }
}

const AlbumFromContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EventFromView);




export default AlbumFromContainer;



// WEBPACK FOOTER //
// ./src/components/AlbumForm/Container.js